import type { ShipmentManagementPickupDeliveryDetails } from "~/shared/schemas/shipment-management-schema.ts";

// Company name and street address are shown to the user as a single line.
export const combineCompanyAddress = (
	details: ShipmentManagementPickupDeliveryDetails,
): string =>
	[details.companyName, details.address]
		.filter((part) => part && part.trim().length > 0)
		.join(", ");
